// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
import InfiniteLoading from 'vue-infinite-loading';
import AuditsService from './admin/audits/audits.service';
import SchedulerControllerService from './admin/scheduler-controller/scheduler-controller.service';

import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import ActivateService from './account/activate/activate.service';
import RegisterService from './account/register/register.service';
import UserManagementService from '@/admin/user-management/user-management.service';

import LoginService from './account/login.service';
import AccountService from './account/account.service';

import '../content/scss/vendor.scss';
import AlertService from '@/shared/alert/alert.service';
import TranslationService from '@/locale/translation.service';
import ConfigurationService from '@/admin/configuration/configuration.service';

import CompanyService from '@/entities/company/company.service';
import CheckListTypeService from '@/entities/check-list-type/check-list-type.service';
import CheckListTplService from '@/entities/check-list-tpl/check-list-tpl.service';
import SectionTplService from '@/entities/section-tpl/section-tpl.service';
import QuestionTplService from '@/entities/question-tpl/question-tpl.service';
import QuestionTplTypeService from '@/entities/question-tpl-type/question-tpl-type.service';
import AnswerTplService from '@/entities/answer-tpl/answer-tpl.service';
import SubmissionStatusService from '@/entities/submission-status/submission-status.service';
import SubmissionHeaderService from '@/entities/submission-header/submission-header.service';
import SubmissionRowService from '@/entities/submission-row/submission-row.service';
import JudgementTypeService from '@/entities/judgement-type/judgement-type.service';
import JudgementService from '@/entities/judgement/judgement.service';
import SubmissionJudgementService from '@/entities/submission-judgement/submission-judgement.service';
import LaboratoryService from '@/entities/laboratory/laboratory.service';
import SupplierService from '@/entities/supplier/supplier.service';
import SupplierFamilyService from '@/entities/supplier-family/supplier-family.service';
import SupplierFamilyTypeService from '@/entities/supplier-family-type/supplier-family-type.service';
import RiskLevelTypeService from '@/entities/risk-level-type/risk-level-type.service';
import AnalysisHeaderService from '@/entities/analysis-header/analysis-header.service';
import AnalysisRowService from '@/entities/analysis-row/analysis-row.service';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import GesDocTypeService from '@/entities/ges-doc-type/ges-doc-type.service';
import GesDocService from '@/entities/ges-doc/ges-doc.service';
import Multiselect from 'vue-multiselect';
import MailTemplateService from '@/entities/mail-template/mail-template.service';
import MailMatrixService from '@/entities/mail-matrix/mail-matrix.service';
import AuditMailService from '@/entities/audit-mail/audit-mail.service';
import PointsService from '@/shared/service/points.service';
import AuditMailTypeService from '@/entities/audit-mail-type/audit-mail-type.service';
import SubmissionStatusTypeService from '@/entities/submission-status-type/submission-status-type.service';
import InsigniaService from '@/entities/insignia/insignia.service';
import AssociateService from '@/entities/associate/associate.service';
import ProductFamilyService from '@/entities/product-family/product-family.service';
import ProductSupplierService from '@/entities/product-supplier/product-supplier.service';
import ProductService from '@/entities/product/product.service';
import ReTypeService from '@/entities/re-type/re-type.service';
import UseTypeService from '@/entities/use-type/use-type.service';
import ReService from '@/entities/re/re.service';
import InspectorService from '@/entities/inspector/inspector.service';
import UserExtraService from '@/entities/user-extra/user-extra.service';
import ContactTypeService from '@/entities/contact-type/contact-type.service';
import ContactService from '@/entities/contact/contact.service';
import ProductAssociateService from '@/entities/product-associate/product-associate.service';
import EanService from '@/entities/ean/ean.service';
import BuyerService from '@/entities/buyer/buyer.service';
import WarehouseService from '@/entities/warehouse/warehouse.service';
import ReportJudgementService from '@/entities/report-judgement/report-judgement.service';
import ReportService from '@/shared/service/report.service';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueSimpleAlert from 'vue-simple-alert';

import CompanyFlawService from '@/entities/company-flaw/company-flaw.service';
import FlawTypeService from '@/entities/flaw-type/flaw-type.service';
// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSimpleAlert);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);
Vue.component('multiselect', Multiselect);
Vue.component('v-select', vSelect);

const VueUploadComponent = require('vue-upload-component');
Vue.component('file-upload', VueUploadComponent);

const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const alertService = new AlertService(store);
const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, router);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    if (!accountService.hasAnyAuthority(to.meta.authorities)) {
      sessionStorage.setItem('requested-url', to.fullPath);
      next('/forbidden');
    } else {
      next();
    }
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    registerService: () => new RegisterService(),
    userService: () => new UserManagementService(),

    auditsService: () => new AuditsService(),
    schedulerControllerService: () => new SchedulerControllerService(),

    healthService: () => new HealthService(),

    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    alertService: () => alertService,
    translationService: () => translationService,
    companyService: () => new CompanyService(),
    checkListTypeService: () => new CheckListTypeService(),
    checkListTplService: () => new CheckListTplService(),
    sectionTplService: () => new SectionTplService(),
    questionTplService: () => new QuestionTplService(),
    questionTplTypeService: () => new QuestionTplTypeService(),
    answerTplService: () => new AnswerTplService(),
    submissionStatusService: () => new SubmissionStatusService(),
    submissionHeaderService: () => new SubmissionHeaderService(),
    submissionRowService: () => new SubmissionRowService(),
    judgementTypeService: () => new JudgementTypeService(),
    judgementService: () => new JudgementService(),
    submissionJudgementService: () => new SubmissionJudgementService(),
    laboratoryService: () => new LaboratoryService(),
    supplierService: () => new SupplierService(),
    supplierFamilyService: () => new SupplierFamilyService(),
    supplierFamilyTypeService: () => new SupplierFamilyTypeService(),
    riskLevelTypeService: () => new RiskLevelTypeService(),
    analysisHeaderService: () => new AnalysisHeaderService(),
    analysisRowService: () => new AnalysisRowService(),
    gesDocTypeService: () => new GesDocTypeService(),
    gesDocService: () => new GesDocService(),
    mailTemplateService: () => new MailTemplateService(),
    mailMatrixService: () => new MailMatrixService(),
    auditMailService: () => new AuditMailService(),
    auditMailTypeService: () => new AuditMailTypeService(),
    submissionStatusTypeService: () => new SubmissionStatusTypeService(),
    insigniaService: () => new InsigniaService(),
    associateService: () => new AssociateService(),
    productFamilyService: () => new ProductFamilyService(),
    productSupplierService: () => new ProductSupplierService(),
    productService: () => new ProductService(),
    reTypeService: () => new ReTypeService(),
    useTypeService: () => new UseTypeService(),
    reService: () => new ReService(),
    inspectorService: () => new InspectorService(),
    userExtraService: () => new UserExtraService(),
    contactTypeService: () => new ContactTypeService(),
    contactService: () => new ContactService(),
    productAssociateService: () => new ProductAssociateService(),
    eanService: () => new EanService(),
    buyerService: () => new BuyerService(),
    warehouseService: () => new WarehouseService(),
    reportJudgementService: () => new ReportJudgementService(),
    pointsService: () => new PointsService(),
    reportService: () => new ReportService(),
    companyFlawService: () => new CompanyFlawService(),
    flawTypeService: () => new FlawTypeService(),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService
  },
  i18n,
  store
});
